import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';

export const currencyLabels: Record<Currency, string> = {
  [Currency.PLN]: 'PLN',
  [Currency.EUR]: 'EUR',
  [Currency.USD]: 'USD',
};

export const getCurrencyLabel = (currency: string): string => {
  return currencyLabels[currency as Currency] ?? currency;
};

/**
 * Symbole do wyświetlania kwot. Kod waluty (`PLN`) zostaje tam, gdzie waluta
 * jest wybierana lub nazywana; przy kwocie czyta się symbol (`1 600,00 zł`).
 */
export const currencySymbols: Record<Currency, string> = {
  [Currency.PLN]: 'zł',
  [Currency.EUR]: '€',
  [Currency.USD]: '$',
};

export const getCurrencySymbol = (currency: string): string => {
  return currencySymbols[currency as Currency] ?? currency;
};

export const currencySelectOptions = Object.values(Currency).map((value) => ({
  value,
  label: currencyLabels[value],
}));
